<template>
  <div class="layout_container">
    <div class="headerTop top is-print-hide" v-if="showHomeTop">
      <home-header :company="userName"></home-header>
    </div>
    <!-- <Warn></Warn> -->
    <notification></notification>
    <div :class="renderRouterCls()">
      <Menu v-show="!hideMenu"></Menu>
      <div class="scroller">
        <Banner v-if="isSupervisionRoute" />
        <!-- <tag-view></tag-view> -->
        <transition name="fade-transform" mode="out-in">
          <keep-alive :include="cachedViews">
            <router-view></router-view>
          </keep-alive>
        </transition>
      </div>
    </div>
    <agreement-modal />

    <select-drug-modal />
    <activityOverlay v-if="showActivity && pcDialogShow">
      <div class="img-box">
        <img :src="pcDialog[0].imgUrl" alt="" @click="goActivity(pcDialog[0])" />
        <i class="overlay-close el-icon-circle-close" @click.prevent.stop="handleClose"></i>
        <div class="click-area" @click="goActivity(pcDialog[0])"></div>
      </div>
    </activityOverlay>
    <explorerGuideModal />
    <addressModal />
    <rtcVideo></rtcVideo>
  </div>
</template>
<script>
import homeHeader from '@/components/global/headerNew.vue';
import Menu from '@/components/menuNew/index.vue';
import { getDevHost, Util } from '@/util';
import notification from '@/components/global/notification';
import agreementModal from './modals/agreementModal';
import classnames from 'classnames';
import explorerGuideModal from './modals/explorerGuideModal';
import activityOverlay from '@/components/activity/activityOverlay.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import selectDrugModal from './modals/selectDrugModal';
import addressModal from './modals/addressModal';
// import zim, { zimApi, emojis, tools, GuideDiagnosisClass } from '@zyf2e/zim/lib/drugPlatform';
import Banner from './banner.vue';
// import { registerModule as registerVideoModule } from '@zyf2e/video-service-ecology/lib/videoStore'
import store from '@/store';
import Vue from 'vue';
//import { DragVideoDirective } from '@zyf2e/video-service-ecology/lib/videoStore';
// import { registerModule } from '@zyf2e/zim-ecology/lib/pcstore'
// import NETEASEv1 from '@zyf2e/rtcpc/lib/nertcv1-service';
// import TRTC from '@zyf2e/rtcpc/lib/trtc-service';
import { rtcVideo } from '@zyf2e/video-service-ecology/lib/video.js';
// import videoService, {
//   videoServiceApi,
//   VIDEO_SERVICE_EVENT,
//   videoSdkEvent,
//   sdkLog
// } from '@zyf2e/rtcpc/lib/video-service';
import { registerModule } from '@zyf2e/zim-ecology/lib/pcstore';
import { DragVideoDirective, registerModule as registerVideoModule } from '@zyf2e/video-service-ecology/lib/videoStore';

Vue.directive('drag', DragVideoDirective);

registerVideoModule(store);

registerModule(store);

export default {
  name: 'app',
  data() {
    return {
      tabItems: [],
      showHomeTop: true,
      company: '',
      hideMenu: false, // 隐藏菜单栏布局
      showActivity: true // 满足活动的用户
    };
  },

  computed: {
    ...mapState('global', ['storeInfo']),
    ...mapGetters(['supervision_routes']),
    keepAlive() {
      return this.$store.getters.keepAlive;
    },
    userName() {
      return this.$store.getters.userName;
    },
    cachedViews() {
      return this.$store.getters.cachedViews;
    },
    userId() {
      return this.$store.getters.userId;
    },
    ucUserId() {
      return this.$store.getters.ucUserId;
    },
    isSupervisionRoute() {
      let bol = false;
      const { path } = this.$route;
      if (this.supervision_routes) {
        this.supervision_routes.map(item => {
          if (item?.children) {
            item.children.map(i => {
              if (i.path == path) {
                bol = true;
              }
            });
          } else {
            if (item.path == path) {
              bol = true;
            }
          }
        });
      }
      console.log(bol);

      return bol;
    },
    // pc弹窗活动
    pcDialog() {
      const { resourcePutObj } = this.$store.getters;
      const RESOURCE_TYPE = 'PC_DIALOG';
      if (resourcePutObj[RESOURCE_TYPE]) return resourcePutObj[RESOURCE_TYPE];
      return [];
    },
    // pc活动弹窗是否展示
    pcDialogShow() {
      const { pcDialog } = this;
      if (pcDialog.length) {
        const { id } = pcDialog[0];
      }
      if (pcDialog.length) {
        Telescope.trackEvent({
          trackId: 'zywzpc-click-popscreen-b'
        });
      }

      return !!pcDialog.length;
    }
  },
  methods: {
    ...mapActions('activity', ['getResourcePut']),
    connectIm() {
      import(/* webpackChunkName:'zim' */ /* webpackPreload: true */ '@zyf2e/zim/lib/drugPlatform').then(
        ({ default: zim, zimApi, emojis, tools, GuideDiagnosisClass }) => {
          const uid = this.ucUserId;
          this.$store.dispatch('imInquiryService/SET_guideDiagnosis', GuideDiagnosisClass);
          this.$store.dispatch('imService/setZIMLib', {
            zim,
            zimApi,
            emojis,
            tools
          });

          this.$store.commit('imDebugService/setDebug', true);
          const zimEnvConfig = {
            uid,
            runtime: {
              env: 'H5',
              apigw: Util.getEnv().toUpperCase()
            },
            debug: false,
            db: true,
            // zone: 'shennong.',
            clientInfo: 'PC',
            zone: getDevHost()
          };
          this.$store.commit('imService/SET_ZimConfig', {
            ...zimEnvConfig
          });
          this.$store.dispatch('imService/initIm', {
            uid
          });
        }
      );
    },
    renderRouterCls() {
      return classnames({
        router_container: true,
        hideMenu: this.hideMenu
      });
    },

    handleClose() {
      this.showActivity = false;
    },
    goActivity({ linkUrl, id }) {
      if (!linkUrl) return;
      const { companyName, companyId, isChain, ucUserId, roleListFromBk, mobile } = this.$store.state.global;
      Telescope.trackEvent({
        trackId: 'zywzpc-click-popscreen-d',
        custom: {
          companyId,
          companyName,
          userId: ucUserId,
          mobile,
          isChain,
          roleList: roleListFromBk,
          time: new Date().getTime()
        }
      });
      // 待参数给跳转页面
      let query =
        linkUrl.indexOf(location.origin) >= 0 ? 'resourceType=PC_DIALOG' : `userId=${ucUserId}&resourceType=PC_DIALOG`;
      query = linkUrl.indexOf('?') > -1 ? `&${query}` : `?${query}`;
      linkUrl = `${linkUrl}${query}`;
      window.open(linkUrl);
      this.showActivity = false;
    },
    initRtcLerna() {
      this.initHookEvent();
      this.zysdkInit();
    },
    initHookEvent() {
      import(/* webpackChunkName:'zim' */ /* webpackPreload: true */ '@zyf2e/rtcpc/lib/video-service').then(
        ({ default: videoService }) => {
          videoService._hooks.onInitDone.tap('onInitDone', data => {
            // const { roleListFromBk } = this.$store.state.global;
            // const code = 'remote_trial_pharmacist';
            this.loginNERTCAccount();
            // const el = roleListFromBk.find(el => el.code == code);
            // if (el && el.code) {
            // 加个逻辑 远程药师也登录下腾讯
            // this.loginTRTCAccount();
            // }
          });
          videoService._hooks.onCallTargetReject.tap('onCallTargetReject', data => {
            this.$message({
              message: '对方暂时无法接听',
              type: 'warning'
            });
          });
        }
      );
    },
    loginNERTCAccount() {
      this.$store.dispatch('video_nertcv1/loginNERTCV1Account', {});
    },
    loginTRTCAccount() {
      this.$store.dispatch('video_trtcVideoStore/loginTRTCAccount', {});
    },
    zysdkInit() {
      Promise.all([
        import(/* webpackChunkName:'zim' */ /* webpackPreload: true */ '@zyf2e/rtcpc/lib/nertcv1-service'),
        import(/* webpackChunkName:'zim' */ /* webpackPreload: true */ '@zyf2e/rtcpc/lib/trtc-service'),
        import(/* webpackChunkName:'zim' */ /* webpackPreload: true */ '@zyf2e/rtcpc/lib/video-service')
      ]).then(result => {
        console.log('##result', result);
        const [
          { default: NETEASEv1 },
          { default: TRTC },
          { default: videoService, videoServiceApi, VIDEO_SERVICE_EVENT, videoSdkEvent, sdkLog }
        ] = result;

        const {
          TRTC: trtcAppid,
          NERTCV1APPID,
          bizId,
          appId,
          VIDEO_ZONE,
          apigw
        } = JSON.parse(process.env.VUE_APP_VIDEO_SDK);
        const param = {
          userId: this.ucUserId,
          bizId,
          appId,
          apigw,
          timeout: 90,
          business: {},
          channelType: 'DPA-PC',
          sdkAppIDObject: {
            trtcSdkAppID: trtcAppid,
            nertcv1SdkAppID: NERTCV1APPID
          },
          zone: '',
          scene: '',
          sdkLib: {
            videoService,
            videoServiceApi,
            VIDEO_SERVICE_EVENT,
            videoSdkEvent,
            TRTC,
            NETEASEv1,
            sdkLog
          },
          debug: true
          // debug: false
        };
        this.$store.dispatch('video_controller/zyRtcInit', param);
      });
    }
  },
  created() {
    this.getResourcePut();
    this.$store.dispatch('prescription/contactStoreVideo');
  },

  mounted() {
    this.connectIm();
    this.$store.dispatch('messageSupervision/haveMessage');
    this.initRtcLerna();
  },
  watch: {
    $route: {
      handler() {
        // 后期可能有需要隐藏菜单栏的路由 同时修正布局 已经做好备用
        /* if (this.$route.name == 'messageCenter') {
          this.hideMenu = true;
        } else {
          this.hideMenu = false;
        } */
      },
      immediate: true
    }
  },
  components: {
    homeHeader,
    Menu,
    Banner,
    notification,
    agreementModal,
    activityOverlay,
    explorerGuideModal,
    selectDrugModal,
    addressModal,
    rtcVideo
  }
};
</script>

<style lang="scss" scope>
.layout_container {
  height: 100%;
}
.top {
  background: #fff;
}
.router_container {
  // padding: 100px 40px 50px;
  padding-top: 48px;
  // min-width: 1200px;
  // min-width: 1148px;
  min-width: 1024px;
  margin: 0 auto;
  height: 100%;
  .scroller {
    // float: left;
    // max-width: 100px;
    min-width: 784px;
    overflow: scroll;
    height: 100%;
    position: relative;
    // min-height: calc(100vh - 48px);
    // height: 100%;
    // padding-left: 240px;
    padding-left: 216px;
    padding-top: 18px;
    padding-right: 16px;
    background: #f5f5f5;
    padding-bottom: 20px;
  }
}
.hideMenu {
  .scroller {
    // float: left;
    // max-width: 100px;
    min-width: 784px;
    overflow: scroll;
    height: 100%;

    padding-left: 0px;
    // padding-left: 256px;
    padding-top: 18px;
    padding-right: 16px;
    background: #fafafa;
    padding-bottom: 20px;
  }
}

@media print {
  //打印特殊处理一下布局
  .router_container {
    padding-top: 0 !important;
    min-width: auto !important;
    margin: 0 !important;
    height: auto !important;
    .scroller {
      padding: 0;
      min-width: auto !important;
      overflow: auto !important;
      height: auto !important;
      padding: 0 !important;
      background: #ffffff !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.headerTop {
  position: fixed;
  width: 100%;
  z-index: 10;
}

.img-box {
  width: 378px;
  margin: 200px auto 100px auto;
  position: relative;
  .overlay-close {
    position: absolute;
    top: -30px;
    right: -40px;
    color: #fff;
    font-size: 24px;
    cursor: pointer;
  }
  img {
    width: 100%;
  }
  .click-area {
    position: absolute;
    margin: 0 auto;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    height: 60px;
    cursor: pointer;
  }
}
</style>
